import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToProfileIfNotAdmin: NavigationGuard = (to, from, next) => {
  if (useAuthStore().isUserAdmin) {
    return next();
  } else {
    next({ name: 'settings-account-profile' });
  }
};

export const redirectToProfileIfNotAdminOrTeamlead: NavigationGuard = (to, from, next) => {
  if (useAuthStore().isUserAdmin || useAuthStore().isUserTeamlead) {
    return next();
  } else {
    next({ name: 'settings-account-profile' });
  }
};

export const redirectToProfileIfNoAccess = (
  permission: keyof ReturnType<typeof useAuthStore>['appAccess']['settings']['company']
): NavigationGuard => {
  return (to, from, next) => {
    const authStore = useAuthStore();
    if (authStore.appAccess.settings.company[permission]) {
      return next();
    } else {
      next({ name: 'settings-account-profile' });
    }
  };
};
